export default [
  {
    path: '/booking-followups', name: 'booking-followups', component: () => import('@/views/pages/bookingFollowups/BookingFollowups.vue'), meta: { resource: 'bookingFollowup', action: 'read', pageTitle: 'پیگیری درخواست‌های نوبت' },
  },
  {
    path: '/operational-reports', name: 'operational-reports', component: () => import('@/views/pages/contentCampaign/OperationalReports.vue'), meta: { resource: 'operationalReporting', action: 'read', pageTitle: 'گزارش نوبت و سرویس‌ها' },
  },
  {
    path: '/content-campaigns', name: 'content-campaign-list', component: () => import('@/views/pages/contentCampaign/CampaignList.vue'), meta: { resource: 'contentCampaign', action: 'read', pageTitle: 'کمپین‌های محتوا' },
  },
  {
    path: '/content-campaigns/new', name: 'content-campaign-create', component: () => import('@/views/pages/contentCampaign/CampaignEditor.vue'), meta: { resource: 'contentCampaign', action: 'manage', pageTitle: 'کمپین جدید' },
  },
  {
    path: '/content-campaigns/reports', name: 'content-campaign-reports', component: () => import('@/views/pages/contentCampaign/CampaignReports.vue'), meta: { resource: 'contentCampaign', action: 'report', pageTitle: 'گزارش کمپین‌ها' },
  },
  {
    path: '/content-campaigns/:id', name: 'content-campaign-edit', component: () => import('@/views/pages/contentCampaign/CampaignEditor.vue'), meta: { resource: 'contentCampaign', action: 'read', pageTitle: 'کمپین محتوا' },
  },
]
